module.exports = __webpack_public_path__ + "img/NYC - Natural History Museum.d3b0ae3c.jpeg";